"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dialogBodyTokens = void 0;
const Global_1 = require("../../DesignSystem/tokens/Global");
const DesignToken_1 = __importDefault(require("../../DesignSystem/types/DesignToken"));
const dialogDescriptionPaddingVertical = new DesignToken_1.default({
    name: 'dialog-description-paddingVertical',
    parent: [Global_1.globalTokens.spacingM, Global_1.globalTokens.oldTokens.sizeSpaceS]
});
const dialogDescriptionBorderWidth = new DesignToken_1.default({
    name: 'dialog-description-borderWidth',
    parent: [Global_1.globalTokens.borderWidthS, Global_1.globalTokens.oldTokens.borderWidthS]
});
const dialogDescriptionBorderColor = new DesignToken_1.default({
    name: 'dialog-description-borderColor',
    parent: [Global_1.globalTokens.colorStrokeDefaultDefault, Global_1.globalTokens.oldTokens.colorBorderMain]
});
const dialogContentPaddingVertical = new DesignToken_1.default({
    name: 'dialog-content-paddingVertical',
    parent: [Global_1.globalTokens.spacingM, Global_1.globalTokens.oldTokens.sizeSpaceM]
});
const dialogDescriptionIndent = new DesignToken_1.default({
    name: 'dialog-description-indent',
    parent: [Global_1.globalTokens.spacingS, Global_1.globalTokens.oldTokens.sizeSpaceXS]
});
// Title
const dialogDescriptionTitleFontSize = new DesignToken_1.default({
    name: 'dialog-description-title-fontSize',
    parent: [Global_1.globalTokens.fontSizeL, Global_1.globalTokens.oldTokens.fontSizeM]
});
const dialogDescriptionTitleFontWeight = new DesignToken_1.default({
    name: 'dialog-description-title-fontWeight',
    parent: [Global_1.globalTokens.fontWeightMedium, Global_1.globalTokens.oldTokens.fontWeightBold]
});
const dialogDescriptionTitleLineHeight = new DesignToken_1.default({
    name: 'dialog-description-title-lineHeight',
    parent: [Global_1.globalTokens.lineHeightL, Global_1.globalTokens.oldTokens.lineHeightM]
});
const dialogDescriptionTitleColor = new DesignToken_1.default({
    name: 'dialog-description-title-color',
    parent: [Global_1.globalTokens.colorForegroundDefaultPrimary, Global_1.globalTokens.oldTokens.colorTextMain]
});
// Text
const dialogDescriptionTextFontSize = new DesignToken_1.default({
    name: 'dialog-description-text-fontSize',
    parent: [Global_1.globalTokens.fontSizeM, Global_1.globalTokens.oldTokens.fontSizeM]
});
const dialogDescriptionTextFontWeight = new DesignToken_1.default({
    name: 'dialog-description-text-fontWeight',
    parent: [Global_1.globalTokens.fontWeightRegular, Global_1.globalTokens.oldTokens.fontWeightNormal]
});
const dialogDescriptionTextLineHeight = new DesignToken_1.default({
    name: 'dialog-description-text-lineHeight',
    parent: [Global_1.globalTokens.lineHeightM, Global_1.globalTokens.oldTokens.lineHeightM]
});
const dialogDescriptionTextColor = new DesignToken_1.default({
    name: 'dialog-description-text-color',
    parent: [Global_1.globalTokens.colorForegroundDefaultPrimary, Global_1.globalTokens.oldTokens.colorTextMain]
});
// Content
const dialogContentFontSize = new DesignToken_1.default({
    name: 'dialog-content-fontSize',
    parent: [Global_1.globalTokens.fontSizeM, Global_1.globalTokens.oldTokens.fontSizeM]
});
const dialogContentFontWeight = new DesignToken_1.default({
    name: 'dialog-content-fontWeight',
    parent: [Global_1.globalTokens.fontWeightRegular, Global_1.globalTokens.oldTokens.fontWeightNormal]
});
exports.dialogBodyTokens = {
    dialogDescriptionTitleFontSize,
    dialogDescriptionTitleFontWeight,
    dialogDescriptionTitleLineHeight,
    dialogDescriptionTitleColor,
    dialogDescriptionTextFontSize,
    dialogDescriptionTextFontWeight,
    dialogDescriptionTextLineHeight,
    dialogDescriptionTextColor,
    dialogContentPaddingVertical,
    dialogContentFontSize,
    dialogContentFontWeight,
    dialogDescriptionIndent,
    dialogDescriptionPaddingVertical,
    dialogDescriptionBorderWidth,
    dialogDescriptionBorderColor
};
//# sourceMappingURL=DialogBody.js.map